import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { appRoutes } from '../../../routes/routes';
import { subscribeToSFStatus } from '../../../services/salesforce';
import styles from './SalesforceTile.module.scss';

export const SalesforceTile = () => {
  const companyId = useSelector(
    (s) => s.auth.profile?.activeCompany?.companyId
  );
  const history = useHistory();

  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    const unsub = subscribeToSFStatus(companyId, (status) =>
      setConnected(status.connected)
    );
    return unsub;
  }, [companyId]);

  return (
    <div
      className={styles.tile}
      onClick={() => history.push(appRoutes().integrationsSalesforce)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) =>
        e.key === 'Enter' && history.push(appRoutes().integrationsSalesforce)
      }
    >
      <div className={styles.logo}>SF</div>
      <div className={styles.body}>
        <div className={styles.titleRow}>
          <span className={styles.name}>Salesforce</span>
          <span
            className={`${styles.badge} ${connected ? styles.connected : styles.disconnected}`}
          >
            {connected ? 'Connected' : 'Not Connected'}
          </span>
        </div>
        <p className={styles.description}>
          Sync Prodaff employees to Salesforce Contacts for unified workforce
          visibility.
        </p>
      </div>
      <div className={styles.arrow}>›</div>
    </div>
  );
};
